import PermissionGuard from 'components/Global/PermissionGuard'; // adjust the path if necessary
import LeaveEncashReportComponent from 'components/Report/LeaveEncashmentReport';

const LeaveEncashReport= () => {
	return (
		<PermissionGuard permission="Allow_Payroll_Reports">
			<LeaveEncashReportComponent />
		</PermissionGuard>
	);
};

export default LeaveEncashReport;
